import React from 'react';
import {useSelector} from 'react-redux';

import {Screens} from '../enums';
import {RootState} from '../store';
import {Home} from '../screens/tabs/Home';
import {Social} from '../screens/tabs/Social';
import {Contact} from '../screens/tabs/Contact';
import {Location} from '../screens/tabs/Location';
import {Categories} from '../screens/tabs/Categories';

export const TabNavigator: React.FC = () => {
  const currentTabScreen = useSelector(
    (state: RootState) => state.tabSlice.screen,
  );

  const renderScreen = (): JSX.Element | null => {
    // Home screen
    if (currentTabScreen === Screens.Home) {
      return <Home />;
    }

    // Services screen
    if (currentTabScreen === Screens.Search) {
      return <Categories />;
    }

    // Contact screen
    if (currentTabScreen === Screens.Cart) {
      return <Contact />;
    }

    // Location screen
    if (currentTabScreen === Screens.Wishlist) {
      return <Location />;
    }

    // Social screen
    if (currentTabScreen === Screens.Profile) {
      return <Social />;
    }

    return null;
  };

  return renderScreen();
};
